//get dashboard

export const GET_DASHBOARD_REQUEST = "GET_DASHBOARD_REQUEST";
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS";
export const GET_DASHBOARD_FAILURE = "GET_DASHBOARD_FAILURE";

export const CLEAR_DASHBOARD_DATA = "CLEAR_DASHBOARD_DATA";

//get charts
export const GET_DASHBOARD_CHART_REQUEST = "GET_DASHBOARD_CHART_REQUEST";
export const GET_DASHBOARD_CHART_SUCCESS = "GET_DASHBOARD_CHART_SUCCESS";
export const GET_DASHBOARD_CHART_FAILURE = "GET_DASHBOARD_CHART_FAILURE";

export const GET_DASHBOARD_CHART_PARALLEL_REQUEST = "GET_DASHBOARD_CHART_PARALLEL_REQUEST";
export const GET_DASHBOARD_CHART_PARALLEL_SUCCESS = "GET_DASHBOARD_CHART_PARALLEL_SUCCESS";
export const GET_DASHBOARD_CHART_PARALLEL_FAILURE = "GET_DASHBOARD_CHART_PARALLEL_FAILURE";

//get fcicharts
export const GET_DASHBOARD_FCI_CHART_REQUEST = "GET_DASHBOARD_FCI_CHART_REQUEST";
export const GET_DASHBOARD_FCI_CHART_SUCCESS = "GET_DASHBOARD_FCI_CHART_SUCCESS";
export const GET_DASHBOARD_FCI_CHART_FAILURE = "GET_DASHBOARD_FCI_CHART_FAILURE";

//get map
export const GET_DASHBOARD_MAP_CHART_REQUEST = "GET_DASHBOARD_MAP_CHART_REQUEST";
export const GET_DASHBOARD_MAP_CHART_SUCCESS = "GET_DASHBOARD_MAP_CHART_SUCCESS";
export const GET_DASHBOARD_MAP_CHART_FAILURE = "GET_DASHBOARD_MAP_CHART_FAILURE";

//get horizontal charts
export const GET_DASHBOARD_HORIZONTAL_CHART_REQUEST = "GET_DASHBOARD_HORIZONTAL_CHART_REQUEST";
export const GET_DASHBOARD_HORIZONTAL_CHART_SUCCESS = "GET_DASHBOARD_HORIZONTAL_CHART_SUCCESS";
export const GET_DASHBOARD_HORIZONTAL_CHART_FAILURE = "GET_DASHBOARD_HORIZONTAL_CHART_FAILURE";

//get filter project
export const GET_FILTER_PROJECT_REQUEST = "GET_FILTER_PROJECT_REQUEST";
export const GET_FILTER_PROJECT_SUCCESS = "GET_FILTER_PROJECT_SUCCESS";
export const GET_FILTER_PROJECT_FAILURE = "GET_FILTER_PROJECT_FAILURE";

//get legents
export const GET_LEGENTS_REQUEST = "GET_LEGENTS_REQUEST";
export const GET_LEGENTS_SUCCESS = "GET_LEGENTS_SUCCESS";
export const GET_LEGENTS_FAILURE = "GET_LEGENTS_FAILURE";

export const MODIFY_FILTER_REQUEST = "MODIFY_FILTER_REQUEST";

export const MODIFY_POP_UP_REQUEST = "MODIFY_POP_UP_REQUEST";

//get landing page data
export const GET_LANDING_PAGE_REQUEST = "GET_LANDING_PAGE_REQUEST";
export const GET_LANDING_PAGE_SUCCESS = "GET_LANDING_PAGE_SUCCESS";
export const GET_LANDING_PAGE_FAILURE = "GET_LANDING_PAGE_FAILURE";

//get landing page reports
export const GET_LANDING_PAGE_REPORT_REQUEST = "GET_LANDING_PAGE_REPORT_REQUEST";
export const GET_LANDING_PAGE_REPORT_SUCCESS = "GET_LANDING_PAGE_REPORT_SUCCESS";
export const GET_LANDING_PAGE_REPORT_FAILURE = "GET_LANDING_PAGE_REPORT_FAILURE";

//get widget data
export const GET_WIDGET_DATA_REQUEST = "GET_WIDGET_DATA_REQUEST";
export const GET_WIDGET_DATA_SUCCESS = "GET_WIDGET_DATA_SUCCESS";
export const GET_WIDGET_DATA_FAILURE = "GET_WIDGET_DATA_FAILURE";

export const UPDATE_FULL_SCREEN_SUCCESS = "UPDATE_FULL_SCREEN_SUCCESS";
export const UPDATE_FULL_SCREEN_FAILURE = "UPDATE_FULL_SCREEN_FAILURE";

export const UPDATE_IS_BUDGET_PRIORITY_VIEW_SUCCESS = "UPDATE_IS_BUDGET_PRIORITY_VIEW_SUCCESS";
export const UPDATE_IS_BUDGET_PRIORITY_VIEW_FAILURE = "UPDATE_IS_BUDGET_PRIORITY_VIEW_FAILURE";

export const UPDATE_TRACKER_MENU_SUCCESS = "UPDATE_TRACKER_MENU_SUCCESS";
export const SET_ACTIVE_MENU_SUCCESS = "SET_ACTIVE_MENU_SUCCESS";

export const UPDATE_DEFAULT_PROJECT = "UPDATE_DEFAULT_PROJECT";

export const TOGGLE_DASHBOARD_RESET_FLAG = "TOGGLE_DASHBOARD_RESET_FLAG";

export const SAVE_INDIVIDUAL_CHART_PARAMS = "SAVE_INDIVIDUAL_CHART_PARAMS";
export const UPDATE_MASTER_FILTER = "UPDATE_MASTER_FILTER";
export const SEED_AI_FILTER_LABELS = "SEED_AI_FILTER_LABELS";
export const SAVE_TEMP_CHART_FILTERS = "SAVE_TEMP_CHART_FILTERS";
export const SAVE_QUERY_TEMP_CHART_FILTERS = "SAVE_QUERY_TEMP_CHART_FILTERS";

export const SAVE_FILTER_REQUEST = "SAVE_FILTER_REQUEST";
export const SAVE_FILTER_SUCCESS = "SAVE_FILTER_SUCCESS";
export const SAVE_FILTER_FAILURE = "SAVE_FILTER_FAILURE";

export const GET_QUERY_REQUEST = "GET_QUERY_REQUEST";
export const GET_QUERY_SUCCESS = "GET_QUERY_SUCCESS";
export const GET_QUERY_FAILURE = "GET_QUERY_FAILURE";

export const DELETE_QUERY_REQUEST = "DELETE_QUERY_REQUEST";
export const DELETE_QUERY_SUCCESS = "DELETE_QUERY_SUCCESS";
export const DELETE_QUERY_FAILURE = "DELETE_QUERY_FAILURE";

export const UPDATE_FILTER_REQUEST = "UPDATE_FILTER_REQUEST";
export const UPDATE_FILTER_SUCCESS = "UPDATE_FILTER_SUCCESS";
export const UPDATE_FILTER_FAILURE = "UPDATE_FILTER_FAILURE";

export const UPDATE_FILTER_NAME = "UPDATE_FILTER_NAME";

export const ADD_QUERY_TO_FAVORITES_REQUEST = "ADD_QUERY_TO_FAVORITES_REQUEST";
export const ADD_QUERY_TO_FAVORITES_SUCCESS = "ADD_QUERY_TO_FAVORITES_SUCCESS";
export const ADD_QUERY_TO_FAVORITES_FAILURE = "ADD_QUERY_TO_FAVORITES_FAILURE";

export const ASSIGN_FAVORITE_QUERY_TO_USERS_REQUEST = "ASSIGN_FAVORITE_QUERY_TO_USERS_REQUEST";
export const ASSIGN_FAVORITE_QUERY_TO_USERS_SUCCESS = "ASSIGN_FAVORITE_QUERY_TO_USERS_SUCCESS";
export const ASSIGN_FAVORITE_QUERY_TO_USERS_FAILURE = "ASSIGN_FAVORITE_QUERY_TO_USERS_FAILURE";

export const GET_USERS_BY_CLIENT_QUERY_REQUEST = "GET_USERS_BY_CLIENT_QUERY_REQUEST";
export const GET_USERS_BY_CLIENT_QUERY_SUCCESS = "GET_USERS_BY_CLIENT_QUERY_SUCCESS";
export const GET_USERS_BY_CLIENT_QUERY_FAILURE = "GET_USERS_BY_CLIENT_QUERY_FAILURE";
export const CLEAR_USER_BY_CLIENT_QUERY_DATA = "CLEAR_USER_BY_CLIENT_QUERY_DATA";

export const GET_QUERY_FILTER_CREATED_USERS_REQUEST = "GET_QUERY_FILTER_CREATED_USERS_REQUEST";
export const GET_QUERY_FILTER_CREATED_USERS_SUCCESS = "GET_QUERY_FILTER_CREATED_USERS_SUCCESS";
export const GET_QUERY_FILTER_CREATED_USERS_FAILURE = "GET_QUERY_FILTER_CREATED_USERS_FAILURE";
export const CLEAR_QUERY_FILTER_CREATED_USERS = "CLEAR_QUERY_FILTER_CREATED_USERS";

export const GET_QUICK_LINKS_REQUEST = "GET_QUICK_LINKS_REQUEST";
export const GET_QUICK_LINKS_SUCCESS = "GET_QUICK_LINKS_SUCCESS";
export const GET_QUICK_LINKS_FAILURE = "GET_QUICK_LINKS_FAILURE";

export const ADD_TO_QUICK_LINKS_REQUEST = "ADD_TO_QUICK_LINKS_REQUEST";
export const ADD_TO_QUICK_LINKS_SUCCESS = "ADD_TO_QUICK_LINKS_SUCCESS";
export const ADD_TO_QUICK_LINKS_FAILURE = "ADD_TO_QUICK_LINKS_FAILURE";

export const UPDATE_QUICK_LINKS_REQUEST = "UPDATE_QUICK_LINKS_REQUEST";
export const UPDATE_QUICK_LINKS_SUCCESS = "UPDATE_QUICK_LINKS_SUCCESS";
export const UPDATE_QUICK_LINKS_FAILURE = "UPDATE_QUICK_LINKS_FAILURE";

export const DELETE_QUICK_LINKS_REQUEST = "DELETE_QUICK_LINKS_REQUEST";
export const DELETE_QUICK_LINKS_SUCCESS = "DELETE_QUICK_LINKS_SUCCESS";
export const DELETE_QUICK_LINKS_FAILURE = "DELETE_QUICK_LINKS_FAILURE";

export const DEFAULT_COLORS = [
    "#0018A8",
    "#bada55",
    "#66FF00",
    "#800080",
    "#3E8EDE",
    "#00bfff",
    "#7B68EE",
    "#7fe5f0",
    "#8a2be2",
    "#407294",
    "#5ac18e",
    "#576675",
    "#008080",
    "#ffd700",
    "#7CFC00",
    "#ffa500",
    "#00ffff",
    "#40e0d0",
    "#0000ff",
    "#b0e0e6",
    "#c6e2ff",
    "#003366",
    "#7fffd4",
    "#00ff00",
    "#4ca3dd",
    "#468499",
    "#00ced1",
    "#6897bb"
];
//get dashboard

export const GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_REQUEST = "GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_REQUEST";
export const GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_SUCCESS = "GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_SUCCESS";
export const GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_FAILURE = "GET_DASHBOARD_MAP_LEASE_ASSET_COUNT_FAILURE";

export const GET_CHART_DYNAMIC_FIELDS_REQUEST = "GET_CHART_DYNAMIC_FIELDS_REQUEST";
export const GET_CHART_DYNAMIC_FIELDS_SUCCESS = "GET_CHART_DYNAMIC_FIELDS_SUCCESS";

// Otto (AI filter assistant) — chart-option vocabulary for the "Asset Uniformat Levels" grouping.
// Consumed by dashboard/chartOptionSources.js to build Otto's chart app_context.
export const UNIFORMAT_LEVEL_CHART_TYPES = [
    "uniformat_level_1s",
    "uniformat_level_2s",
    "uniformat_level_3s",
    "uniformat_level_4s",
    "uniformat_level_5s",
    "uniformat_level_6s"
];

export const UNIFORMAT_LEVEL_FILTER_MAP = {
    uniformat_level_1s: { filterKey: "uniformat_level_1s_ids", label: "Uniformat Level 1" },
    uniformat_level_2s: { filterKey: "uniformat_level_2s_ids", label: "Uniformat Level 2" },
    uniformat_level_3s: { filterKey: "uniformat_level_3s_ids", label: "Uniformat Level 3" },
    uniformat_level_4s: { filterKey: "uniformat_level_4s_ids", label: "Uniformat Level 4" },
    uniformat_level_5s: { filterKey: "uniformat_level_5s_ids", label: "Uniformat Level 5" },
    uniformat_level_6s: { filterKey: "uniformat_level_6s_ids", label: "Uniformat Level 6" }
};

export const ASSET_UNIFORMAT_LEVEL_CHART_OPTIONS = {
    label: "Asset Uniformat Levels",
    options: UNIFORMAT_LEVEL_CHART_TYPES.map((value, i) => ({
        label: `Uniformat Level ${i + 1}`,
        value,
        isRegularChart: true
    }))
};
export const GET_CHART_DYNAMIC_FIELDS_FAILURE = "GET_CHART_DYNAMIC_FIELDS_FAILURE";